import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import {
  DEFAULT_JIRA_INSTANCE,
  JIRA_INSTANCES,
  JiraInstance,
} from '../../components/jira/presets';

const PROJECT_KEY_PARAMETER = 'jiraProjectKey';
const INSTANCE_PARAMETER = 'jira';

type FormContext = { formData?: unknown } | undefined;

const formDataOf = (formContext: FormContext): Record<string, unknown> => {
  const data = formContext?.formData;
  return data && typeof data === 'object'
    ? (data as Record<string, unknown>)
    : {};
};

export const jiraProjectKeyOf = (formContext: FormContext): string => {
  const value = formDataOf(formContext)[PROJECT_KEY_PARAMETER];
  return typeof value === 'string' ? value.trim() : '';
};

export const jiraInstanceOf = (formContext: FormContext): JiraInstance => {
  const instance = formDataOf(formContext)[INSTANCE_PARAMETER];
  const named =
    instance && typeof instance === 'object'
      ? (instance as { instance?: unknown }).instance
      : undefined;
  return JIRA_INSTANCES.find(known => known === named) ?? DEFAULT_JIRA_INSTANCE;
};

export const jiraProjectFieldSchema = makeFieldSchema({
  output: z => z.string(),
  uiOptions: z => z.object({}).optional(),
});

export const jiraBoardsFieldSchema = makeFieldSchema({
  output: z =>
    z.object({
      boardIds: z.array(z.number()),
      filterIds: z.array(z.string()).min(1),
    }),
  uiOptions: z => z.object({}).optional(),
});
